import { tagNameSchema } from "@gioia365/contracts";
import { entryTagKey, isUsableTagName } from "@gioia365/domain/lead-entry";
import { normalizeSearchText } from "@gioia365/domain/search-text";

// «Crea il tag «…»» (24/10/2026): il nome scritto nella casella dei tag diventa un tag nuovo soltanto se il server lo accetta (lo
// stesso schema della rotta, `tagNameSchema`, e `isUsableTagName`: almeno una lettera o una cifra, niente «Owner:») e se non c'è già
// un tag con la stessa chiave degli ingressi (senza maiuscole, accenti e segni: `entryTagKey`). La casella filtra con la stessa
// normalizzazione, così un tag che la chiave dice uguale resta sempre in vista e si sceglie. Il server controlla di nuovo e, se nel
// frattempo il tag è nato, restituisce quello.

/** Il nome del tag nuovo che la voce propone, ripulito; `null` se la voce non c'è. */
export function newTagName(typed: string, known: ReadonlyArray<{ name: string }>): string | null {
  const parsed = tagNameSchema.safeParse(typed);
  if (!parsed.success || !isUsableTagName(parsed.data)) return null;
  const key = entryTagKey(parsed.data);
  return known.some((tag) => entryTagKey(tag.name) === key) ? null : parsed.data;
}

/** I tag che rispondono a ciò che è scritto, con la stessa normalizzazione della chiave; tutti se non c'è niente da cercare. */
export function tagsMatching<T extends { name: string }>(tags: readonly T[], typed: string): T[] {
  const q = normalizeSearchText(typed);
  return q ? tags.filter((tag) => normalizeSearchText(tag.name).includes(q)) : [...tags];
}
